import { useState } from 'react'
import styled from 'styled-components'
import Type from 'components/Type'
import PropTypes from 'prop-types'
import ClickAwayListener from '@mui/material/ClickAwayListener'
import Box from '@mui/material/Box'
import Tooltip from '@mui/material/Tooltip'
import Stack from '@mui/material/Stack'
import { text as textColor } from 'theme/palette'

const StyledInfoButton = styled.div.withConfig({
  shouldForwardProp: prop => ![
    'color',
    'inline',
  ].includes(prop),
})`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  border-radius: 15px;
  border-style: solid;
  border-width: ${props => props.theme.globals.borderWidth.main};
  border-color: ${props => props.theme.palette.text[props.color]};
  color: ${props => props.theme.palette.text[props.color]};
  height: 13px;
  width: 13px;
  font-size: 10px;
  line-height: 1;
  ${props =>
    !props.inline &&
    `
    margin-left: 4px;
    margin-right: 4px;
  `}
  user-select: none;
  cursor: pointer;
  transition: ${props => props.theme.state.transition.main};
`

const Letter = styled.div`
  font-size: 10px;
  line-height: 11px;
  color: inherit;
  text-transform: none !important;
  font-weight: 400 !important;
`

const InfoButton = ({
  label,
  color,
  inline,
  inverse,
  flip,
  disableTooltip,
  labelProps,
  popoverProps,
  children,
  onClick,
  ...props
}) => {
  const [open, setOpen] = useState(false)

  const renderInfoButton = () => (
    <ClickAwayListener onClickAway={() => setOpen(false)}>
      <Tooltip
        componentsProps={{
          tooltip: {
            className: inverse ? 'inverse' : '',
          },
        }}
        open={disableTooltip ? false : open}
        onOpen={() => setOpen(true)}
        onClose={() => setOpen(false)}
        arrow
        placement="bottom"
        leaveTouchDelay={10000}
        title={<Box p={1}>{children}</Box>}
      >
        <div 
          onTouchStart={() => setOpen(true)} 
        >
          <StyledInfoButton color={color} {...props}>
            <Letter>i</Letter>
          </StyledInfoButton>
        </div>
      </Tooltip>
    </ClickAwayListener>
  )

  return (
    <Stack
      display="inline-grid"
      gridAutoFlow="column"
      gap={0.5}
      alignItems="center"
      justifyContent="flex-start"
      sx={{
        cursor: 'pointer',
      }}
      {...props}
    >
      {!flip && renderInfoButton()}
      {label && (
        <Type variant="dataMicro" color={color} {...labelProps}>
          {label}
        </Type>
      )}
      {flip && renderInfoButton()}
    </Stack>
  )
}

InfoButton.propTypes = {
  label: PropTypes.any,
  color: PropTypes.oneOf(Object.keys(textColor)),
  inverse: PropTypes.bool,
  inline: PropTypes.bool,
  flip: PropTypes.bool,
  disableTooltip: PropTypes.bool,
  labelProps: PropTypes.object,
  popoverProps: PropTypes.object,
  onClick: PropTypes.func,
}

InfoButton.defaultProps = {
  color: 'mainCool',
  labelProps: {},
  popoverProps: { sizeX: 'sm' },
}

export default InfoButton
